import http from 'core/services/http';
import Config from 'core/config';
import axios from 'axios';
import { orderBy } from 'lodash';

class MaterialChainService {
  static getRoomMaterials(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/materials`);
  }

  static setRoomMaterials(roomId, data) {
    return http.put(`${Config.apiUrl}/room/${roomId}/materials`, data);
  }

  static getTCEventMaterialTypes(tcEventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${tcEventId}/materialtypes`);
  }

  static getRoomTypeMaterialTypes(roomTypeId) {
    return http.get(`${Config.apiUrl}/roomtype/${roomTypeId}/materialtypes`);
  }

  static getEventAllMaterials(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/allmaterials`);
  }

  static getEventMaterials(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/materials`);
  }

  static setEventMaterials(eventId, data) {
    return http.put(`${Config.apiUrl}/testcenterevent/${eventId}/materials`, data);
  }

  static getMaterialTypesByRoomTypes(roomTypes) {
    return axios.all(roomTypes.map(roomType => MaterialChainService.getRoomTypeMaterialTypes(roomType.id)));
  }

  static getRoomMaterialsCount(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/roommaterialscount`);
  }
}

export default MaterialChainService;
